module.exports = __webpack_public_path__ + "img/04產品詢問函.b34c776b.jpg";